import script from "./HomeWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeWindow.vue?vue&type=script&lang=ts&setup=true"

import "./HomeWindow.vue?vue&type=style&index=0&id=7f5e4428&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5e4428"]])

export default __exports__